import Home from "./components/Home.vue";
import Admin from "./components/admin/Admin.vue";
import AdminDashboard from './components/admin/Dashboard.vue';

export const routes = [
    { path:'/', component: Home},
    { path:'/admin', component: AdminDashboard}
];



// WEBPACK FOOTER //
// ./src/routes.js